// extracted by mini-css-extract-plugin
module.exports = {"worningStyle":"OverAllocationPopup_worningStyle__3L2Li","iconStyle":"OverAllocationPopup_iconStyle__1o-Sn","loading":"OverAllocationPopup_loading__3NXxg"};